import { PCRModel } from 'services/EpdClient';
import FileService from 'services/FileService';
import { TextButton } from '../buttons';
import { StyledDownloadIcon } from '../epd-compiler-inputs/common-icons';
import React, { useState } from 'react';
import PcrSelectorFilesDialog from '../pcr-selector/pcr-selector/PcrSelectorFilesDialog';
import styled from 'styled-components';
import Tooltip from 'components/controls/Tooltip';

interface Props {
  pcr: PCRModel;
  pcrType: 'main' | 'cpcr';
  label?: string;
}

const DownloadPcrDocument: React.FC<Props> = ({ pcr, pcrType, label }) => {
  const [showFiles, setShowFiles] = useState<boolean>(false);
  const hasNoDocuments = !pcr.documents || pcr.documents.length === 0;
  const handleDownloadSelectedPcrFiles = () => {
    if (pcr.documents && pcr.documents.length > 1) {
      setShowFiles(true);
    } else if (pcr.documents && pcr.documents.length === 1) {
      window.open(FileService.getImageUrl(pcr.documents[0].id || ''), '_blank', 'noreferrer');
    }
  };

  return (
    <>
      <DownloadDiv>
        {/* need to wrap button to display tooltip for disabled button. It's not receiving mouse events */}
        <ButtonWrapper>
          {hasNoDocuments && (
            <Tooltip position="bottom" offset={-6}>
              No file to download
            </Tooltip>
          )}
          <StyledTextButton
            type="button"
            label={label}
            disabled={hasNoDocuments}
            text
            icon={<DownloadIcon />}
            onClick={handleDownloadSelectedPcrFiles}
            $disabled={hasNoDocuments}
          />
        </ButtonWrapper>
      </DownloadDiv>
      <PcrSelectorFilesDialog
        isOpened={showFiles}
        pcrType={pcrType}
        onHide={() => setShowFiles(false)}
        files={pcr.documents ?? []}
      />
    </>
  );
};

const DownloadDiv = styled.div`
  display: flex;
  align-items: center;
`;

const DownloadIcon = styled(StyledDownloadIcon)`
  margin-right: 3px;
  pointer-events: none;
  color: inherit;
  width: 12px;
`;

const StyledTextButton = styled(TextButton)<{ $disabled?: boolean }>`
  cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
`;

const ButtonWrapper = styled.div`
  display: inline-block;
`;

export default DownloadPcrDocument;
